import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'sy-blog-hr',
  styleUrl: './scss/index.scss',
  shadow: true,
})
export class SyBlogHr {
  /**
   * Margin top value in pixels.
   */
  @Prop({ reflect: true }) marginTop = 0;

  /**
   * Margin bottom value in pixels.
   */
  @Prop({ reflect: true }) marginBottom = 0;

  /**
   * Margin thickness value in pixels. Sets the same margin for all sides.
   */
  @Prop({ reflect: true }) thickness = 0;

  private getStyle() {
    return {
      '--sy-blog-hr-margin-top': this.marginTop + 'px',
      '--sy-blog-hr-margin-bottom': this.marginBottom + 'px',
      '--sy-blog-hr-thickness': this.thickness + 'px',
    };
  }

  render() {
    return (
      <Host>
        <div style={this.getStyle()}></div>
      </Host>
    );
  }
}
